import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';

import AcadlyStripeInput, { Props as AcadlyStripeInputProps } from '../FormControls/StripeInput';

type VMProps<T extends FieldValues> = UseControllerProps<T>;

const useStripeInput = <T extends FieldValues>({ control, name, defaultValue }: VMProps<T>) => {
  const controller = useController({
    control,
    name,
    defaultValue,
  });

  const onInputChange = (e: StripePaymentElementChangeEvent) => {
    controller.field.onChange(e);
  };

  return { controller, onInputChange };
};

export type StripeInputProps<T extends FieldValues> = VMProps<T> &
  DistributiveOmit<FieldValues, 'name'> &
  DistributiveOmit<AcadlyStripeInputProps, 'error'>;

const StripeInput = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  ...props
}: StripeInputProps<T>) => {
  const { onInputChange } = useStripeInput({ control, name, defaultValue });

  return <AcadlyStripeInput {...props} onChange={onInputChange} />;
};

export default StripeInput;
